import esContent from './changeDomain.es';

export default {
  ...esContent,
};
